import { Box, Stack } from "@mui/material";
import { PersonalDataDisplay } from "Components/UserAccount/Customer/CustomerParty/PersonalDataDisplay";
import { AddressDisplay } from "Components/UserAccount/Shared/AddressDisplay";
import { DocumentsDisplay } from "Components/UserAccount/Shared/DocumentsDisplay";
import { InfoBox } from "Components/Shared/InfoBox/InfoBox";
import type { PartyDto } from "Infrastructure/Api/Api";
import { useVerificationsQuery } from "Api/Queries/Verifications/useVerificationsQuery";
import { Resources, useResource } from "Translations/Resources";

const RESOURCES = Resources.Components.Account;

type Props = {
  party: PartyDto;
};

export const CustomerParty = ({ party }: Props) => {
  const { t } = useResource();
  const { data: verification } = useVerificationsQuery();

  const { partyIdentification, addresses, publicID } = party;
  const isDocumentExpired =
    verification?.identityVerificationStatus === "Expired";

  return (
    <Stack>
      <Box mb={[2, 2, 4]}>
        <InfoBox
          variant="info"
          content={t(RESOURCES.PersonalDataChangeNotification)}
        />
      </Box>
      <PersonalDataDisplay party={party} />
      <AddressDisplay addresses={addresses} />
      {!!partyIdentification && (
        <DocumentsDisplay
          partyIdentification={partyIdentification}
          partyPublicID={publicID ?? undefined}
          isDocumentExpired={isDocumentExpired}
        />
      )}
    </Stack>
  );
};
